import NoneTag from '../interaction/addNoneTag';

function addNoneTag(cubeIds: CubeId[] = []): void {
    NoneTag.add(cubeIds);
}

export {
    addNoneTag
};
